import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { StatementSelectors } from '@products/store/statement.slice';

export type StatementDialogDeclined = 'decline';

@Component({
  selector: 'app-statement-dialog',
  templateUrl: './statement-dialog.component.html',
  styleUrls: ['./statement-dialog.component.scss'],
})
export class StatementDialogComponent implements OnInit {
  isLoading$: Observable<boolean> = this.store.select(
    StatementSelectors.selectStatementLoading
  );
  hasError$: Observable<boolean> = this.store.select(
    StatementSelectors.selectStatementLoadError
  );

  statement!: string;

  constructor(
    private readonly store: Store,
    @Inject(MAT_DIALOG_DATA)
    public data: { isTakeOver: boolean }
  ) {}

  ngOnInit(): void {
    this.store
      .select(StatementSelectors.selectStatementContent)
      .subscribe((statement) => (this.statement = statement ?? ''));
  }
}
